(function ($) {
  $(document).ready(function () {
    $('.dropdown-toggle, .dropdown-indicator').on('click', function (e) {
      if ($(this).attr('href') && !$(this).attr('href').includes('#')) return true
      e.preventDefault()
      $(this)
        .closest('li')
        .toggleClass('showed')
        .find('.dropdown-menu')
        .toggleClass('show')
    })
    $('.menu-item.showed').find('.dropdown-menu').addClass('show')
  })
})(jQuery)
